module.exports = __webpack_public_path__ + "img/halino.f10872e.png";